import { makeAutoObservable } from 'mobx'

/**
 * Local store of `AssignmentDetailDrawer`.
 * Owns drawer-level UI state: status-change loading/error, modal toggles
 * and a refresh key that forces the inner DelaysSection to re-fetch.
 * Instantiated per drawer mount via `useState(() => new AssignmentDetailDrawerStore())`.
 */
export class AssignmentDetailDrawerStore {
    actionLoading = false
    actionError: string | null = null
    delayModalOpen = false
    completeTaskOpen = false
    delayRefreshKey = 0

    constructor() {
        makeAutoObservable(this)
    }

    setActionLoading(v: boolean): void {
        this.actionLoading = v
    }

    setActionError(v: string | null): void {
        this.actionError = v
    }

    setDelayModalOpen(v: boolean): void {
        this.delayModalOpen = v
    }

    setCompleteTaskOpen(v: boolean): void {
        this.completeTaskOpen = v
    }

    bumpDelayRefreshKey(): void {
        this.delayRefreshKey += 1
    }
}
